import Vue from "Vue";
import profileWidgetInstance from "Shared/profileWidgetInstance";

export default class ProfileWidget {
	constructor(store) {
		this.store = store;
		this._initializeVueInstance();
	}

	_initializeVueInstance() {
		this._profileWidgetInstance = new Vue({
			...profileWidgetInstance(),
			store: this.store
		});
	}
}